import React from 'react';
import { default as MoreText } from 'react-show-more-text';
import styled from 'styled-components';

const StyledMoreText = styled(MoreText)`
	font-size: ${({ fontSize }) => fontSize};
	font-weight: 300;
	text-align: 'justify';
	color: var(--color-light-gray);

	& > span > span {
		max-width: 100% !important;
	}
`;

const TruncationButtonDiv = styled.div`
	display: flex;
	left: 0;
	margin-top: 6px;
	margin-bottom: 6px;
`;

const TruncationButton = styled.button`
	border: none;
	background: none;
	cursor: pointer;
	font-size: var(--font-size-400);
	font-weight: var(--font-weight-600);
	color: var(--color-medium-gray);
	padding: 1px 0px;
`;

const TruncationArrow = styled.i`
	color: 'rgb(77, 77, 79)';
	cursor: pointer;
`;

interface ShowMoreTextProps {
	children: React.ReactNode;
	lines?: number;
	useIcon?: boolean;
	fontSize?: ShowMoreTextFontSizeEnum;
}

enum ShowMoreTextFontSizeEnum {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large'
}

const ShowMoreText = ({
	children,
	lines = 2,
	useIcon = true,
	fontSize = ShowMoreTextFontSizeEnum.LARGE
}: ShowMoreTextProps) => {
	const moreButtonTypeHandler = () => {
		switch (useIcon) {
			case true:
				return <TruncationArrow className="fa fa-chevron-down" />;
			case false:
				return (
					<TruncationButtonDiv>
						<TruncationButton>Show more</TruncationButton>
					</TruncationButtonDiv>
				);
		}
	};

	const lessButtonTypeHandler = () => {
		switch (useIcon) {
			case true:
				return <TruncationArrow className="fa fa-chevron-up" />;
			case false:
				return (
					<TruncationButtonDiv>
						<TruncationButton>Show less</TruncationButton>
					</TruncationButtonDiv>
				);
		}
	};

	return (
		<StyledMoreText
			lines={lines}
			more={moreButtonTypeHandler()}
			less={lessButtonTypeHandler()}
			expanded={false}
			truncatedEndingComponent={'... '}
			fontSize={fontSize}
		>
			{children}
		</StyledMoreText>
	);
};

export default ShowMoreText;
// File renamed to src/features/documents/components/ShowMoreText.tsx
